export const blockIconsHouseholdEmergencyHomeNew = (
	<span className='material-symbols-outlined'>emergency_home</span>
);
